import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getCampaingRepository, {
  ServiceResponse,
} from './getCampaing.repository';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getCampaing = createAsyncThunk(
  'getCampaing',
  async (type: any): Promise<ServiceResponse[]> => {
    return await getCampaingRepository(type).catch((error: any) => {
      throw error;
    });
  }
);

const serviceSlice = createSlice({
  name: 'getCampaing',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCampaing.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getCampaing.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getCampaing.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
